import Image from 'global/Image';
import { assetPrefix } from 'constants/app';
import {
  ImageWithShadow,
  Title,
  ValueMultiMonitor,
  ValuePoints,
  VideoMultiMonitor,
} from './styled';
import { valueIcons } from './constants';
import ValuePointIcon from './ValuePointIcon';

import useResizeObserve from './hooks/useResizeObserve';

const MultiMonitor = () => {
  const { width } = useResizeObserve('.multi-monitor');

  return (
    <>
      <ValueMultiMonitor>
        <Title>
          Tampilan <span className="green"> Multi Monitor</span> untuk Dukung
          Performa Trading Sahammu
        </Title>
        <ValuePoints className="value-points-icon">
          {valueIcons.map((item, index) => (
            <div key={`value-icon-${index + 1}`}>
              <ValuePointIcon
                key={`value-icon-${index + 1}`}
                icon={item.icon}
                text={item.text}
              />
            </div>
          ))}
        </ValuePoints>

        <ImageWithShadow
          className=" image-value image-value image-multi"
          marginTop={-260}
        >
          <Image className="ellipse" src="/images/Ellipse.svg" />
          <div style={{ position: 'relative', top: '0' }}>
            <VideoMultiMonitor
              left={4}
              marginTop={4}
              width={width}
              autoPlay
              loop
              muted
              playsInline
              className=" video-multi-monitor"
            >
              <source src={`${assetPrefix}/homepage/left-monitor.mp4`} />
            </VideoMultiMonitor>
            <VideoMultiMonitor
              right={4}
              marginTop={4}
              width={width}
              autoPlay
              loop
              muted
              playsInline
              className=" video-multi-monitor"
            >
              <source src={`${assetPrefix}/homepage/right-monitor.mp4`} />
            </VideoMultiMonitor>
            <Image
              src="/images/multi-monitor.svg"
              className="image multi-monitor"
            />
          </div>
        </ImageWithShadow>
        <div
          className="end-multi"
          style={{ height: '10px', paddingTop: '198px' }}
        />
      </ValueMultiMonitor>
    </>
  );
};

export default MultiMonitor;
